// Generated by scripts/update-seeq-icons.js from src/svg/seeq/long-dash.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcLongDash = {
  prefix: 'fak',
  iconName: 'long-dash' as IconName,
  icon: [1024, 1024, [], 'f907', 'M880 467.2h-307.2v89.6h451.2v-89.6zM307.2 467.2h-307.2v89.6h451.2v-89.6z'],
} satisfies IconDefinition;
